import React, {useEffect, useState} from 'react';

import {StandardLayout} from "../../layout/StandardLayout";
import UboldSpinner from "../../ubold-components/UboldSpinner";
import MechanicalSettingsService from "./MechanicalSettingsService";
import {Card} from "../../components/Card";
import {NavLink} from "react-router-dom";
import AjaxService from "../../platform/ajax/AjaxService";
import {OptiselModal} from "../../components/modal/OptiselModal";
import {Protected} from "../../layout/Protected";

function TextInput(props) {
    return <div className={"row" + (props.margin ? " mt-2" : "")}>
        <div className="col-4 text-right mt-1">
            <label>{props.label}</label>
        </div>
        <div className="col-3">
            <input className="form-control" name={props.name} type="text" value={props.value} onChange={props.onChange}/>
        </div>
    </div>
}

export default function MechanicalSettingsPage(props) {

    const [settingsValues, setSettingsValues] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        MechanicalSettingsService.fetchSettings()
            .then(data => {
                setSettingsValues(data);
            })
            .finally(() => {
                setLoading(false);
            })
    }, []);

    function save() {
        setLoading(true);
        MechanicalSettingsService.saveSettings(settingsValues)
            .then(data => {
                //    setSettingsValues(data);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    function onFieldChange(e) {
        setSettingsValues({
            ...settingsValues,
            [e.target.name]: e.target.value
        });
    }

    const fields = [];
    Object.keys(settingsValues).forEach(function (key) {
        fields.push(<TextInput name={key} label={key} margin={"mt-2"} value={settingsValues[key]} onChange={onFieldChange}/>);

    });

    const form = <React.Fragment>{fields}
        <div className="row">
            <div className="col-4 mt-3">
            </div>
            <div className="col-4 mt-3">
                <button className="btn  btn-primary" onClick={save}>Zapisz</button>
            </div>
        </div>
    </React.Fragment>;

    const [deleteDialog, setDeleteDialog] = useState(null);

    function requestDelete(mode) {
        setDeleteDialog({phase: "confirming", mode});
    }

    function confirmDelete() {
        const {mode} = deleteDialog;
        const nonPersistentOnly = mode === "non-persistent";
        const limit = 1000;
        setDeleteDialog({phase: "deleting"});
        AjaxService.postJson(`/api/optisel-event/delete-oldest?limit=${limit}&nonPersistentOnly=${nonPersistentOnly}`, {})
            .then(response => {
                setDeleteDialog({phase: "done", result: response.json});
            });
    }

    function formatDeleteResult() {
        const {result} = deleteDialog;
        if (result.deletedCount === 0) {
            return "Brak zdarzeń do usunięcia.";
        }
        const oldest = new Date(result.oldestDeletedInstant).toLocaleString("pl-PL");
        const newest = new Date(result.newestDeletedInstant).toLocaleString("pl-PL");
        return `Usunięto ${result.deletedCount} zdarzeń. Zakres dat: ${oldest} — ${newest}.`;
    }

    return <>
        <Card header={"Ustawienia"}>
            <div className={"alert alert-warning mb-5 p-3"}><i className="fas fa-exclamation-triangle"></i>
                Uwaga - zmiana ustawień mechanicznych może spowodować niepoprawne działanie przykładów Demo,
                ze względu na inne rezultaty obliczeń mechanicznych.
                Dane demonstracyjne są przygotowane dla ustawień: Czas nagłego zatrzymania: 2; Dopuszczalna klasa niewyważenia: 18,9; Stosunek masy AS/SG do Standard: 1,2; Współczynnik bezpieczeństwa sprzęgła: 4
            </div>
            {loading ? <div className={"text-center"}><UboldSpinner/></div> : form}
        </Card>
        <Protected privilege={"PERM_HISTORY_AND_ISSUES_MANAGEMENT"}>
            <>
                <Card header={"Usuwanie historycznych zdarzeń i doborów"} additionalClassNames={"mt-3"}>
                    <p>Uwaga, tutaj można usunąc z systemu historyczne zdarzenia, w tym Historia Doborów. Podstawową operacją powinno być usuwanie zdarzeń niespersystowanych, jako mało istotnych, jednak w przypadku problemów z wydajnością lub miejsca na dysku, można usuać wszystkie najstarsze wydarzenia.</p>
                    <p>Uwaga, jeżeli w systemi nie ma wielu zdarzeń w historii doborów, to usuwanie <b>dowolnych</b> zdarzeń może doprowadzić do usunięcia istotnych dobór dokonanych nidawno lub przypiętych do spraw.</p>
                    <div className={"d-flex gap-2 p-3"}>
                        <button className={"btn btn-warning"} onClick={() => requestDelete("non-persistent")}>
                            <i className={"fas fa-trash"}/> Usuń najstarsze 1000 niespersystowanych zdarzeń
                        </button>
                        <button className={"btn btn-danger"} onClick={() => requestDelete("any")}>
                            <i className={"fas fa-trash"}/> Usuń najstarsze 1000 dowolnych zdarzeń
                        </button>
                    </div>
                </Card>
                <OptiselModal
                    opened={deleteDialog?.phase === "confirming"}
                    header={"Potwierdzenie usunięcia"}
                    closeable={false}
                    onClose={() => setDeleteDialog(null)}
                >
                    <p>Czy na pewno usunąć najstarsze zdarzenia?</p>
                    <div className={"d-flex gap-2 justify-content-end"}>
                        <button className={"btn btn-secondary"} onClick={() => setDeleteDialog(null)}>Anuluj</button>
                        <button className={"btn btn-danger"} onClick={confirmDelete}>Potwierdzam</button>
                    </div>
                </OptiselModal>
                <OptiselModal
                    opened={deleteDialog?.phase === "deleting"}
                    header={"Usuwanie..."}
                    closeable={false}
                    onClose={() => {}}
                >
                    <div className={"text-center"}><UboldSpinner/></div>
                </OptiselModal>
                <OptiselModal
                    opened={deleteDialog?.phase === "done"}
                    header={"Wynik usuwania"}
                    closeable={false}
                    onClose={() => setDeleteDialog(null)}
                >
                    <p>{deleteDialog?.phase === "done" && formatDeleteResult()}</p>
                    <div className={"d-flex justify-content-end"}>
                        <button className={"btn btn-primary"} onClick={() => setDeleteDialog(null)}>OK</button>
                    </div>
                </OptiselModal>
            </>
        </Protected>
    </>;
}

MechanicalSettingsPage.propTypes = {}

MechanicalSettingsPage.defaultProps = {}